import { Component, Inject, input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { AssetsDataService, LevelAsset } from '@services/assets-data.service';
import { AuthenticationService } from '@services/authentication.service';
import { DatapointsDataService } from '@services/datapoints-data.service';
import { VirtualSensor, VirtualSensorsService } from '@services/virtual-sensors.service';
import { combineLatest, takeUntil, distinctUntilChanged, filter } from 'rxjs';
import { siteSubscriptions } from '@services/siteSubscriptions';

/**
 * AddVirtualSensorDialogData
 */
export class AddVirtualSensorDialogData {
	virtualSensors: VirtualSensor[];
	asset: LevelAsset
}

@Component({
	selector: 'app-add-virtual-sensor',
	templateUrl: './add-virtual-sensor.component.html',
	styleUrl: './add-virtual-sensor.component.scss'
})
export class AddVirtualSensorComponent {

	/** Asset */
	public asset: LevelAsset;

	/** virtualSensors */
	public virtualSensors: VirtualSensor[] = [];

	/** assetVirtualSensors */
	public assetVirtualSensors: VirtualSensor[] = [];

	/**
	 * Default Constructor
	 * @param assetsDataService assetsDataService 
	 * @param globalFunctions globalFunctions 
	 * @param authenticationService authenticationService 
	 * @param siteSubscriptions siteSubscriptions 
	 * @param router router 
	 */
	constructor(
		public assetsDataService: AssetsDataService,
		public globalFunctions: GlobalFunctions,
		public authenticationService: AuthenticationService,
		public dialogRef: MatDialogRef<AddVirtualSensorComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: AddVirtualSensorDialogData,
	) {
		if (dialogData.virtualSensors) this.virtualSensors = dialogData.virtualSensors;
		if (dialogData.asset) this.asset = dialogData.asset;
		if (this.virtualSensors && this.asset) {
			this.assetVirtualSensors = this.virtualSensors.filter((vs: VirtualSensor) => vs.AssetIDs.split(",").includes(this.asset.AssetID.toString()));
			this.virtualSensors.forEach((vs: VirtualSensor) => vs._selected = this.assetVirtualSensors.includes(vs));
		}
	}	

	/**
	 * Cancel button for dialog
	 */
	onCancelClick(): void {
		this.dialogRef.close();
	}

	/**
	 * selectVirtualSensor
	 * @param eventevent  
	 */
	selectVirtualSensor(event: any, vs: VirtualSensor) {
		if(event.checked) {
			vs._selected = true;
			this.assetVirtualSensors.push(vs);
		} else {
			vs._selected = false;
			this.assetVirtualSensors = this.assetVirtualSensors.filter((x: VirtualSensor) => x.VirtualSensorID != vs.VirtualSensorID);
		}
	}
}
